// Minimal ULID (Crockford base32, 48-bit time + 80-bit randomness). Works in
// Node, browsers and React Native as long as crypto.getRandomValues exists.

const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

function randomBytes(n: number): Uint8Array {
  const bytes = new Uint8Array(n);
  globalThis.crypto.getRandomValues(bytes);
  return bytes;
}

export function ulid(now: number = Date.now()): string {
  let time = '';
  let t = now;
  for (let i = 0; i < 10; i++) {
    time = ALPHABET[t % 32] + time;
    t = Math.floor(t / 32);
  }
  const rand = randomBytes(16);
  let random = '';
  for (let i = 0; i < 16; i++) random += ALPHABET[rand[i]! % 32];
  return time + random;
}

export const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/;

export function ulidTime(id: string): number {
  let t = 0;
  for (const ch of id.slice(0, 10)) t = t * 32 + ALPHABET.indexOf(ch);
  return t;
}
